import { render, staticRenderFns } from "./EInvoiceStatusBadge.vue?vue&type=template&id=3a35345d&scoped=true"
import script from "./EInvoiceStatusBadge.vue?vue&type=script&lang=js"
export * from "./EInvoiceStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./EInvoiceStatusBadge.vue?vue&type=style&index=0&id=3a35345d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a35345d",
  null
  
)

export default component.exports